import { Navigate, Outlet } from 'react-router-dom';

import { TOKEN_KEY } from '../api';
import { useAuthStore } from '../stores/auth-store';

export function hasValidSession(): boolean {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return false;
  try {
    const payload = token.split('.')[1];
    if (!payload) return false;
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      exp?: number;
    };
    return typeof decoded.exp === 'number' && decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function PrivateRoute() {
  const user = useAuthStore((state) => state.user);
  if (!user || !hasValidSession()) return <Navigate to='/login' replace />;
  return <Outlet />;
}

export function AdminRoute() {
  const user = useAuthStore((state) => state.user);
  if (user?.role !== 'admin') return <Navigate to='/profile' replace />;
  return <Outlet />;
}
